<template>
  <ModalEdit :id="modalId" :title="$t('text.addNote')" no-save-button>
    <div class="p-5">
      <div v-for="(user, index) in list" :key="index">
        <div v-if="user">
          <div class="flex justify-between">
            <p class="mr-3 text-gray-600">{{ $t('text.lastName') }}</p>
            <p class="font-medium">{{ user.lastName || '-' }}</p>
          </div>
          <div class="flex justify-between mt-3">
            <p class="mr-3 text-gray-600">{{ $t('text.firstName') }}</p>
            <p class="font-medium">{{ user.firstName || '-' }}</p>
          </div>
          <div class="flex justify-between mt-3 mb-3">
            <p class="mr-3 text-gray-600">{{ $t('text.phone') }}</p>
            <p class="font-medium">{{ user.phone }}</p>
          </div>
          <Button
            v-if="user.lastName && user.firstName && user.phone"
            @click="onShow(user)"
            class="w-full border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
          >
            {{ $t('text.seeMore') }}
          </Button>
        </div>
      </div>
    </div>
  </ModalEdit>
</template>

<script>
import ModalEdit from '@/components/ui/ModalEdit';
import baseModalMixin from '@/mixins/baseModalMixin';
import Button from '@/components/ui/button/Button';

export default {
  mixins: [baseModalMixin],

  props: {
    list: Array,
  },

  methods: {
    async onShow(user) {
      await this.hideEditModal();
      this.$router.push({ name: 'CustomerDetails', params: { customerId: user.id } });
    },
  },

  components: {
    ModalEdit,
    Button,
  },
};
</script>
